import 'vuetify/styles/core'
import 'vuetify/styles/utilities'
import './plugins/vuetify.css'

import 'unfonts.css'
import '@mdi/font/css/materialdesignicons.css'
import 'flag-icons/css/flag-icons.min.css'
import './styles/main.css'

import './plugins/datadog.ts'
import './plugins/survicate.ts'
import { initOneTrust } from './plugins/onetrust'
import './plugins/userguiding.ts'

import { createApp } from 'vue'
import { enablePatches } from 'immer'
import router from './router/index.ts'
import vuetify, { rulesPlugin } from './plugins/vuetify.js'
import head from './plugins/unhead.js'
import i18n from './plugins/i18n.js'
import { VueQueryPlugin, vueQueryOptions } from './plugins/vue-query.js'
import pinia from './plugins/pinia.js'
import JsonEditorPlugin, { jsonEditorConfig } from './plugins/json-editor.js'
import { vPhoneInputPlugin } from './plugins/v-phone-input.js'
import App from './App.vue'
import './utils/pwa.ts'

initOneTrust()
enablePatches()

export const app = createApp(App)

app
  .use(router)
  .use(i18n)
  .use(vuetify)
  .use(rulesPlugin)
  .use(head)
  .use(pinia)
  .use(VueQueryPlugin, vueQueryOptions)
  .use(JsonEditorPlugin, jsonEditorConfig)
  .use(vPhoneInputPlugin)

app.mount('#app')
